import { useTableTranslation } from './translations';
import { EmptyState } from './assets/EmptyState';
import { ResetFiltersButton } from './filters/ResetFiltersButton';

export type TableEmptyStateProps = {
  noResultsText?: string;
};

export const TableEmptyState = ({ noResultsText }: TableEmptyStateProps) => {
  const { t } = useTableTranslation();
  return (
    <div className="pointer-events-none absolute inset-0 top-11 z-5 overflow-hidden p-8">
      <div className="pointer-events-auto mx-auto flex h-full w-full max-w-150 flex-col items-center justify-center gap-6">
        <EmptyState className="h-auto max-h-[min(20rem,calc(100%-7.5rem))] w-auto max-w-full" />
        <span className="shrink-0 text-s18 text-text-secondary">{noResultsText || t('noSearchResults')}</span>
        <ResetFiltersButton className="shrink-0" variant="outlined" />
      </div>
    </div>
  );
};
